import React from 'react'
import loadable from '@loadable/component'

const imageblock = loadable(() =>
    import('./ImageBlock').then((module) => ({
        default: module.imageblock
    }))
)

const iconfeatures = loadable(
    () =>
        import(
            /* webpackChunkName: "Icon-Features" */ '../components/IconFeature/IconFeature'
        )
)
// const basicblock = loadable(() =>
//     import('../components/BasicBlock').then((module) => ({
//         default: module.basicblock
//     }))
// )
const basicblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Basic-Block" */ '../components/BasicBlock/BasicBlock'
        )
)
// const quotesection = loadable(() =>
//     import('../components/Quote').then((module) => ({
//         default: module.quotesection
//     }))
// )
const quotesection = loadable(
    () =>
        import(
            /* webpackChunkName: "Quote-Section" */ '../components/Quote/Quote'
        )
)
// case study cards
// const casestudycard = loadable(() =>
//     import('../components/CaseStudy').then((module) => ({
//         default: module.casestudycard
//     }))
// )

const casestudycard = loadable(
    () =>
        import(
            /* webpackChunkName: "Case-Study-Card" */ '../components/CaseStudy/CaseStudy'
        )
)

// const careersblock = loadable(() =>
//     import('../components/CareerFilter').then((module) => ({
//         default: module.careersblock
//     }))
// )

const careersblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Career-Filter" */ '../components/CareerFilter/CareerFilter'
        )
)

// const peoplecards = loadable(() =>
//     import('../components/PeopleCard').then((module) => ({
//         default: module.peoplecards
//     }))
// )

const peoplecards = loadable(
    () =>
        import(
            /* webpackChunkName: "People-Card" */ '../components/PeopleCard/PeopleCard'
        )
)

// const locationblock = loadable(() =>
//     import('../components/LocationCard').then((module) => ({
//         default: module.locationblock
//     }))
// )

const locationblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Location-Card" */ '../components/LocationCard/LocationCard'
        )
)

// const heroblock = loadable(() =>
//     import('../components/HeroBlock').then((module) => ({
//         default: module.heroblock
//     }))
// )

// const logocards = loadable(() =>
//     import('../components/LogoCard').then((module) => ({
//         default: module.logocards
//     }))
// )

const logocards = loadable(
    () =>
        import(
            /* webpackChunkName: "Logo-Card" */ '../components/LogoCard/LogoCard'
        )
)

// const imagecards = loadable(() =>
//     import('../components/ImageCard').then((module) => ({
//         default: module.imagecards
//     }))
// )

const imagecards = loadable(
    () =>
        import(
            /* webpackChunkName: "Image-Card" */ '../components/ImageCard/ImageCard'
        )
)

// const titleblock = loadable(() =>
//     import('../components/Tile').then((module) => ({
//         default: module.titleblock
//     }))
// )

const titleblock = loadable(
    () => import(/* webpackChunkName: "Tile" */ '../components/Tile/Tile')
)
// Home Links block
const homelinks = loadable(
    () =>
        import(
            /* webpackChunkName: "Home-Links" */ '../components/HomeLink/HomeLink'
        )
)
// Home Video Preview block
const videopreview = loadable(
    () =>
        import(
            /* webpackChunkName: "Video-Preview" */ '../components/VideoPreview/VideoPreview'
        )
)
//Logos section
const logossection = loadable(
    () =>
        import(
            /* webpackChunkName: "Logo-Section" */ '../components/LogoSection/LogoSection'
        )
)

// single text block
const singletextblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Single-Text" */ '../components/SingleText/SingleText'
        )
)

// Carousel block
const carouselblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Carousel" */ '../components/Carousel/Carousel'
        )
)
// Spacer block
const spacer = loadable(() => import('../components/Spacer/Spacer'))

// Text block accent
const textblockaccent = loadable(
    () =>
        import(
            /* webpackChunkName: "Carousel" */ '../components/TextBlockAccent/TextBlockAccent'
        )
)
// Internal hero
const internalhero = loadable(
    () =>
        import(
            /* webpackChunkName: "Carousel" */ '../components/InternalHero/InternalHero'
        )
)

// Hero story block
const herostoryblock = loadable(
    () =>
        import(
            /* webpackChunkName: "HeroStory-Block" */ '../components/HeroStoryBlock/HeroStoryBlock'
        )
)

// Map text
const maptext = loadable(
    () =>
        import(
            /* webpackChunkName: "Map-Text" */ '../components/MapText/MapText'
        )
)

// Client cards
const clientcards = loadable(
    () =>
        import(
            /* webpackChunkName: "Client-Cards" */ '../components/ClientCards/ClientCards'
        )
)
// Partner cards
const partnercards = loadable(
    () =>
        import(
            /* webpackChunkName: "Partner-Cards" */ '../components/PartnerCards/PartnerCards'
        )
)
// Partner with us
const partnerwithus = loadable(
    () =>
        import(
            /* webpackChunkName: "Partner-With-Us" */ '../components/PartnerWithUs/PartnerWithUs'
        )
)
// Partner with us
const textblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Text-Block" */ '../components/TextBlock/TextBlock'
        )
)
// Contact form
const hubspotform = loadable(
    () =>
        import(
            /* webpackChunkName: "Contact-Form" */ '../components/ContactForm/ContactForm'
        )
)

// Partner with us
const titleblockwithshape = loadable(
    () =>
        import(
            /* webpackChunkName: "Title-Block-With-Shape" */ '../components/TitleBlockWithShape/TitleBlockWithShape'
        )
)

// Industry Card
const industrycard = loadable(
    () =>
        import(
            /* webpackChunkName: "Title-Block-With-Shape" */ '../components/IndustryCard/IndustryCard'
        )
)

//Content Image
const contentimageblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Content-Image-Block" */ './ContentImageBlock/ContentImageBlock'
        )
)

//Latest Resources
const latestresources = loadable(
    () =>
        import(
            /* webpackChunkName: "Latest-Resources" */ './LatestResources/LatestResources'
        )
)

//Industry Services
const industryservices = loadable(
    () =>
        import(
            /* webpackChunkName: "Industry-Services" */ './IndustryServices/IndustryServices'
        )
)

// Industry Hero
const industryhero = loadable(
    () =>
        import(
            /* webpackChunkName: "Industry-Hero" */ './IndustryHero/IndustryHero'
        )
)

//Carousel Solution
const carouselsolution = loadable(
    () =>
        import(
            /* webpackChunkName: "Carousel-Solution" */ './CarouselSolution/CarouselSolution'
        )
)
//Solution Form
const solutionform = loadable(
    () =>
        import(
            /* webpackChunkName: "Solution-Form" */ './SolutionForm/SolutionForm'
        )
)

const sdcalltoaction = loadable(
    () =>
        import(
            /* webpackChunkName: "SD-Call-To-Action" */ './SDCallToAction/SDCallToAction'
        )
)
//Card Slider Expand
const cardsliderexpand = loadable(
    () =>
        import(
            /* webpackChunkName: "Card-Slider-Expand" */ './CardSliderExpand/CardSliderExpand'
        )
)
const heroiconblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Hero-Icon-Block" */ './HeroIconBlock/HeroIconBlock'
        )
)
const titleiconblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Title-Icon-Block" */ './TitleIconBlock/TitleIconBlock'
        )
)
const statisticblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Statistic-Block" */ './StatisticBlock/StatisticBlock'
        )
)
const socialmediablock = loadable(
    () =>
        import(
            /* webpackChunkName: "Social-Media-Block" */ './SocialMediaBlock/SocialMediaBlock'
        )
)
const wysiwygblock = loadable(
    () =>
        import(
            /* webpackChunkName: "WYSIWYG-Block" */ './WYSIWYGBlock/WYSIWYGBlock'
        )
)

const downloadresourceblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Download-Resource" */ './DownloadResource/DownloadResource'
        )
)
const downloadmodalblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Download-Modal" */ './DownloadModal/DownloadModal'
        )
)
const roundtableheroblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Hero-Customer-Block" */ './HeroCustomerBlock/HeroCustomerBlock'
        )
)
const eventsscheduleblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Events-Schedule" */ './EventsSchedule/EventsSchedule'
        )
)
const timelocationblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Time-Location-Block" */ './TimeLocationBlock/TimeLocationBlock'
        )
)
const fallback = loadable(
    () => import(/* webpackChunkName: "Fallback" */ './Fallback/Fallback')
)
const clienthero = loadable(
    () =>
        import(/* webpackChunkName: "Client-Hero" */ './ClientHero/ClientHero')
)
const clientsummary = loadable(
    () =>
        import(
            /* webpackChunkName: "Client-Summary" */ './ClientSummary/ClientSummary'
        )
)
const clienttestimonial = loadable(
    () =>
        import(
            /* webpackChunkName: "Client-Summary" */ './ClientTestimonial/ClientTestimonial'
        )
)

const cyberheroblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Cyber-Hero" */ './CyberSecurityAssessment/Landing/Hero'
        )
)
const cyberinfoblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Client-Summary" */ './CyberSecurityAssessment/Landing/ImageText'
        )
)
const cyberbannerblock = loadable(
    () =>
        import(
            /* webpackChunkName: "Cyber-Banner" */ './CyberSecurityAssessment/Landing/BannerImage'
        )
)

// Cyber Security Blocks
const cybersecurityhero = loadable(
    () => import(/* webpackChunkName: "Cyber-Hero" */ './CyberSecurity/Hero')
)
const cybersecurityapproach = loadable(
    () =>
        import(
            /* webpackChunkName: "Cyber-Approach" */ './CyberSecurity/Approach'
        )
)
const cybersecurityimagetext = loadable(
    () =>
        import(
            /* webpackChunkName: "Cyber-ImageText" */ './CyberSecurity/ImageText'
        )
)
const cybersecurityoutcomes = loadable(
    () =>
        import(
            /* webpackChunkName: "Cyber-Outcomes" */ './CyberSecurity/Outcomes'
        )
)
const cybersecurityservices = loadable(
    () =>
        import(
            /* webpackChunkName: "Cyber-Services" */ './CyberSecurity/Services'
        )
)
const cybersecuritystatistics = loadable(
    () =>
        import(
            /* webpackChunkName: "Cyber-Statistics" */ './CyberSecurity/Statistics'
        )
)
const cybersecuritystrategy = loadable(
    () =>
        import(
            /* webpackChunkName: "Cyber-Strategy" */ './CyberSecurity/Strategy'
        )
)
const cybersecurityvideo = loadable(
    () =>
        import(
            /* webpackChunkName: "Cyber-Strategy" */ './CyberSecurity/Siem/Video'
        )
)
const blockMap = {
    iconfeatures,
    basicblock,
    quotesection,
    casestudycard,
    careersblock,
    locationblock,
    // heroblock,
    peoplecards,
    titleblock,
    logocards,
    imagecards,
    homelinks,
    videopreview,
    logossection,
    singletextblock,
    carouselblock,
    textblockaccent,
    spacer,
    internalhero,
    herostoryblock,
    maptext,
    clientcards,
    partnercards,
    partnerwithus,
    textblock,
    hubspotform,
    titleblockwithshape,
    industrycard,
    contentimageblock,
    industryservices,
    latestresources,
    carouselsolution,
    industryhero,
    solutionform,
    sdcalltoaction,
    cardsliderexpand,
    wysiwygblock,
    socialmediablock,
    imageblock,
    statisticblock,
    titleiconblock,
    heroiconblock,
    downloadresourceblock,
    downloadmodalblock,
    roundtableheroblock,
    eventsscheduleblock,
    timelocationblock,
    fallback,
    clienthero,
    clientsummary,
    clienttestimonial,
    cyberheroblock,
    cyberinfoblock,
    cyberbannerblock,
    // Cyber security blocks
    cybersecurityhero,
    cybersecurityapproach,
    cybersecurityimagetext,
    cybersecurityoutcomes,
    cybersecurityservices,
    cybersecuritystatistics,
    cybersecuritystrategy,
    cybersecurityvideo
}
export default blockMap
